import React, { useState } from 'react';
import Icon from '../components/Icon';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const set = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      return setError('Please fill in all required fields.');
    }
    setSent(true);
    setError('');
  };

  return (
    <div className="static-page">
      <div className="static-page__hero">
        <h1>Contact Us</h1>
        <p>Have a question or need help? We'd love to hear from you.</p>
      </div>

      <div className="static-page__body">
        <div className="contact-layout">
          <div className="contact-info">
            <h2>Get in touch</h2>
            <p style={{ color: 'var(--text-dim)', marginBottom: '2rem', lineHeight: 1.7 }}>
              Whether you're a student with a question about your classes,
              or you need technical support, reach out and we'll get back to you within 24 hours.
            </p>

            {[
              { icon: 'mail', label: 'Email', value: 'metkarianis09@gmail.com' },
              { icon: 'location', label: 'Location', value: 'India (Online Platform)' },
              { icon: 'clock', label: 'Response Time', value: 'Within 24 hours' },
            ].map(c => (
              <div key={c.label} className="contact-detail">
                <span className="icon-badge contact-detail__icon"><Icon name={c.icon} size={20} /></span>
                <div>
                  <strong>{c.label}</strong>
                  <p>{c.value}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="contact-form-wrap">
            {sent ? (
              <div className="contact-success">
                <h3>Message sent!</h3>
                <p>Thanks for reaching out, {form.name}. We'll reply to {form.email} within 24 hours.</p>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <h2>Send a message</h2>

                {error && <div className="error-msg">{error}</div>}

                <div className="form-group">
                  <label>Your Name *</label>
                  <input placeholder="Full name" value={form.name} onChange={set('name')} required />
                </div>
                <div className="form-group">
                  <label>Email Address *</label>
                  <input type="email" placeholder="you@example.com" value={form.email} onChange={set('email')} required />
                </div>
                <div className="form-group">
                  <label>Subject</label>
                  <select value={form.subject} onChange={set('subject')}>
                    <option value="">Select a topic</option>
                    <option>Sessions / Meetings</option>
                    <option>Technical Support</option>
                    <option>Billing / Payment</option>
                    <option>General Enquiry</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Message *</label>
                  <textarea
                    placeholder="Describe your question or issue..."
                    value={form.message}
                    onChange={set('message')}
                    rows={5}
                    required
                  />
                </div>
                <button type="submit" className="btn-primary">Send Message</button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
